import { useUpsellFunnel } from '@hooks';
import { PageHeader } from '@organisms';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { TabComponent } from 'src/app/components/antd/TabComponent';

export const UpsellFunnel: React.FC = () => {
  const navigate = useNavigate();

  const {
    onChangeMenu,
    indexSelectedMenu,
    labelsMenu,
    tabActive: { Component },
  } = useUpsellFunnel();
  return (
    <>
      <PageHeader
        backToPath={() => {
          navigate(-1);
        }}
        title={'Gestão de Funil Upsell'}
        subTitle={'Gerencie, edite e crie novas etapas de Funil.'}
      />

      <TabComponent
        tabList={labelsMenu}
        onChangeTab={onChangeMenu}
        activeKey={indexSelectedMenu}
        defaultActiveKey={indexSelectedMenu}
      />

      <Component />
    </>
  );
};
